// Added by Sejune Oh on 2020-02-28
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    Checkbox  as MaterialUICheckbox,
    CheckboxProps as MaterialUICheckboxProps
} from '@material-ui/core'

interface CheckboxBaseProps { }
export type CheckboxProps = Partial<MaterialUICheckboxProps> & CheckboxBaseProps

export const Checkbox: FC<CheckboxProps> = ({ ...props }) => {
    return <MaterialUICheckbox {...props}></MaterialUICheckbox>
}
